import {
    Locale,
    GameName,
    DefaultLocale,
    gameSettings,
} from "inbox-contentful";

const gameName: GameName = "brawlstars";

export const config = {
    gameName,
    gameResolution: {
        x: 500,
        y: 320,
    },
    locales: (gameSettings[gameName]?.enabledLocales ?? [DefaultLocale]).filter(
        (x) => x !== "zh-hans",
    ) as Locale[],
    tabs: ["news", "community", "esport"],
    isFullScreen: false,
};
